import { memo as Memo } from 'react';

//* HOC's
import withLanguageContext from '@context/consumerHOC/LanguageConsumer';

//* Components
import Select from '../Select';
import Text from '@/components/global/Text';

const SelectDate = Memo((props) => {
	//! Constructing Object For Select Element
	const selectProps = () => {
		let obj = {
			name: props.name,
			required: props.required,
			placeholder: props.placeholder,
			mobileDefault: true,
			leftIcon: (
				<Text
					tag={'span'}
					className='ma-calendar'>
					<Text
						tag={'span'}
						className='path1'
					/>
					<Text
						tag={'span'}
						className='path2'
					/>
					<Text
						tag={'span'}
						className='path3'
					/>
					<Text
						tag={'span'}
						className='path4'
					/>
					<Text
						tag={'span'}
						className='path5'
					/>
					<Text
						tag={'span'}
						className='path6'
					/>
					<Text
						tag={'span'}
						className='path7'
					/>
					<Text
						tag={'span'}
						className='path8'
					/>
					<Text
						tag={'span'}
						className='path9'
					/>
					<Text
						tag={'span'}
						className='path10'
					/>
					<Text
						tag={'span'}
						className='path11'
					/>
					<Text
						tag={'span'}
						className='path12'
					/>
				</Text>
			),
		};

		const length = props.days.length;
		let list = [];
		for (let i = 0; i < length; i++) {
			const el = props.days[i],
				label = el.today ? props.translate('today') : el.tomorrow ? props.translate('tomorrow') : props.translate(el.day.short) + ', ' + props.translate(el.month) + '/' + props.translate(el.date),
				value = el.fullDate;

			list = [...list, { label, value }];

			if (props.value && (props.value === value || props.value === el.today || props.value === el.tomorrow)) {
				if (props.value === props.parentVal) {
					props.onChange(props.name, value);
				}

				obj = { ...obj, value };
			}
		}

		obj = { ...obj, list };
		return obj;
	};

	return (
		<Select
			{...props}
			{...selectProps()}
		/>
	);
});

export default withLanguageContext(SelectDate, ['translate']);
